module.exports = __webpack_public_path__ + "static/media/idea.a5534043.png";